<div class="addContainer" style="width: 100%">
  <div class="modalHeader" style="display: flex; justify-content: space-between; align-items: center">
    <div class="modalHeader clearfix">
      <div class="modal-about">
        <div class="font-weight-bold p-t-5 ms-2 me-2 font-17">
          Edit Announcement
        </div>
      </div>
    </div>
    <button mat-icon-button (click)="onCancel()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <form [formGroup]="editForm" class="register-form">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <label class="plain-label" for="title">Title *</label>
          <mat-form-field class="example-full-width" appearance="outline">
            <input formControlName="title" matInput required />
            <mat-error *ngIf="editForm.get('title').hasError('required')">
              Title is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <label class="plain-label" for="announcementCategory">Category *</label>
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-select formControlName="announcementCategory" required>
              <mat-option value="Upcoming Event">Upcoming Event</mat-option>
              <mat-option value="New Comers">New Comers</mat-option>
              <mat-option value="Prayer Requests">Prayer Requests</mat-option>
              <mat-option value="Financial Givings">Financial Givings</mat-option>
              <mat-option value="others">Others</mat-option>
            </mat-select>
            <mat-error *ngIf="editForm.get('announcementCategory').hasError('required')">
              Category is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <label class="plain-label" for="announcementDate">Date *</label>
          <mat-form-field class="example-full-width" appearance="outline">
            <input type="date" formControlName="announcementDate" matInput required />
            <mat-error *ngIf="editForm.get('announcementDate').hasError('required')">
              Date is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <label class="plain-label" for="message">Message *</label>
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea formControlName="message" matInput required rows="4"></textarea>
            <mat-error *ngIf="editForm.get('message').hasError('required')">
              Message is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <button mat-raised-button type="button" (click)="onUpdate()" [disabled]="editForm.invalid" 
        style="background-color: #48B5E1; color: #FFFFFF;">
        <mat-icon>update</mat-icon>
        Update
      </button>
      <button mat-raised-button type="button" (click)="onCancel()" 
        style="margin-left: 10px; background-color: #312B2A; color: #FFFFFF;">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
    </form>
  </div>
</div>
